import React from "react";
import { Box, Typography } from "@mui/material";
import StripeProductIconsPanel from "../../pages/advertisement/StripeProductIconsPanel";
import { STRIPE_PRODUCT_ICON_VARIANTS } from "../../pages/advertisement/StripeProductIconSvg";

/** Admin AD → Tutor: Stripe Tutor Standard product image with download. */
export default function TutorsAdPage() {
    return (
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5 }}>
                Tutor Standard
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, maxWidth: 720 }}>
                512×512 product image for Stripe. Company logo in the background, with a book
                and pencil on top. Download PNG and upload it on Stripe → Product catalog →
                Tutor Standard → Edit product → image.
            </Typography>
            <StripeProductIconsPanel variants={[STRIPE_PRODUCT_ICON_VARIANTS.TUTOR_STANDARD]} />
        </Box>
    );
}
